import { render, staticRenderFns } from "./SharedManuscriptContent.vue?vue&type=template&id=3ca8cb28&scoped=true&"
import script from "./SharedManuscriptContent.vue?vue&type=script&lang=ts&"
export * from "./SharedManuscriptContent.vue?vue&type=script&lang=ts&"
import style0 from "./SharedManuscriptContent.vue?vue&type=style&index=0&id=3ca8cb28&lang=scss&scoped=true&"
import style1 from "./SharedManuscriptContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca8cb28",
  null
  
)

export default component.exports